<app-layout-dialogheader1 [title]="'Change Options for supervision'" [titlesub]="''" mat-dialog-title>
</app-layout-dialogheader1>
<mat-dialog-content>
    <mat-progress-bar mode="indeterminate" *ngIf="loadinglist"></mat-progress-bar>
    <app-frms-messagebar #frmsmessagebar *ngIf="alertmessage" [alertmessage]="alertmessage"></app-frms-messagebar>
    <!--     <div class="custom-control custom-radio statusitem" >
      <mat-radio-group [(ngModel)]="statusselected">
        <mat-radio-button [value]="item.id" *ngFor="let item of statuslist">{{item.name}}</mat-radio-button>        
      </mat-radio-group>
    </div> -->
    <ng-container *ngIf="isValidator">
        <h5>Validation</h5>
        <ul class="list-group">
            <li class="list-group-item withpointer" (click)="changeIssuesOptionsValueByField('movenext',changeValue(supervCmp.issuesComponent_options.movenext))">
                <app-check-box-icon [checked]="supervCmp.issuesComponent_options.movenext"></app-check-box-icon>
                On Save issue goto next
            </li>
        </ul>        
    </ng-container>

    <h5>Map</h5>
    <ul class="list-group">
        <li class="list-group-item withpointer" (click)="changeMapOptionsValueByField('map_panel_onclick_showThermal',changeValue(supervCmp.map_options.map_panel_onclick_showThermal))" matTooltip="Show the thermal image of the issue/panel clicked on map">
            <app-check-box-icon [checked]="supervCmp.map_options.map_panel_onclick_showThermal"></app-check-box-icon>
            Show issue thermal image when click on panel
        </li>
        <li class="list-group-item withpointer" (click)="changeMapOptionsValueByField('map_panel_onclick_showImageProjected',changeValue(supervCmp.map_options.map_panel_onclick_showImageProjected))" matTooltip="Show the thermal image of the issue/panel clicked on map">
            <app-check-box-icon [checked]="supervCmp.map_options.map_panel_onclick_showImageProjected"></app-check-box-icon>
            Show flight image projection when change issue
        </li>        
    </ul>
<!--     <ul class="nav flex-column">
        <li class="nav-item">
          <a class="nav-link"  (click)="supervCmp.map_options.map_panel_onclick_showThermal=changeValue(supervCmp.map_options.map_panel_onclick_showThermal)">
            <app-check-box-icon [checked]="supervCmp.map_options.map_panel_onclick_showThermal"></app-check-box-icon>
            Show panel image when click on
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="#">Link</a>
        </li>
        <li class="nav-item">
          <a class="nav-link disabled" href="#" tabindex="-1" aria-disabled="true">Disabled</a>
        </li>
      </ul> -->

</mat-dialog-content>
<div mat-dialog-actions style="width:100%;" class="justify-content-end mat-dialog-actions">
    <button mat-raised-button mat-dialog-close class="btn pull-right">Close</button>
</div>